import { render, staticRenderFns } from "./SettingTable.vue?vue&type=template&id=be55a74c&scoped=true&"
import script from "./SettingTable.vue?vue&type=script&lang=js&"
export * from "./SettingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be55a74c",
  null
  
)

export default component.exports